<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="user-settings" fluid pt-0>
    <v-app-bar app color="black" dark fixed>
      <hb-back-button :fallback-params="{
              id: vastuualue.id,
              vuosi: valinta?.vuosi || vuosi
            }" :forced-fallback="true" fallback="vastuualue"/>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $tc('tehtava.title', 2) }}</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading && hasPermissions">
        <v-col class="mt-2" cols="12" offset-xl="1" xl="10">
          <v-row>
            <v-col cols="12">
              <v-card color="#191919" outlined>
                <v-card-title primary-title>

                  {{ $tc('tehtava.title', 2) }}
                  <v-spacer></v-spacer>
                  <v-btn v-if="$hasEditPermission(vastuualue.id)" color="primary"
                         small
                         @click="openEdit(null)">
                    <v-icon left>mdi mdi-plus</v-icon>
                    {{ $t('tehtava.lisaa_tehtava') }}
                  </v-btn>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                  <v-row class="align-center">
                    <v-col cols="12" md="12">
                      <div class="text-h6">
                        {{ $tc('vastuualue.title', 1) }} -
                        {{ vastuualue.nimi }}
                      </div>
                      <div v-if="valinta" class="subtitle-1">
                        {{ valinta.otsikko }} {{ valinta.vuosi }}
                      </div>
                      <!--<div v-if="vastuualue.vastuuuser" class="caption">
                        {{ vastuualue.vastuuuser.firstname }}
                        {{ vastuualue.vastuuuser.lastname }}
                      </div>-->
                    </v-col>

                  </v-row>
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field v-model="search.text" :label="$t('search')"/>
                      <v-autocomplete
                          :disabled="saving"
                          :item-text="(item) => item.otsikko"
                          :items="filteredValinnat"
                          :label="$tc('valinta.title',1)"
                          :value="valinta"
                          clearable
                          item-value="id"
                          return-object
                          validate-on-blur
                          @change="onChangeValinta"
                      ></v-autocomplete>
                      <v-autocomplete
                          v-model="henkilo"
                          :disabled="saving"
                          :item-text="(item) => item.firstname + ' ' + item.lastname"
                          :items="henkilot"
                          :label="$t('tehtava.vastuuuser')"
                          clearable
                          item-value="id"
                          return-object
                          validate-on-blur

                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-checkbox v-model="search.aloittamatta"
                                  :label="$t('tehtava.search.aloittamatta')" dense
                                  hide-details/>
                      <v-checkbox v-model="search.kaynnissa"
                                  :label="$t('tehtava.search.kaynnissa')" dense
                                  hide-details/>
                      <v-checkbox v-model="search.valmis" :label="$t('tehtava.search.valmis')"
                                  dense hide-details/>
                    </v-col>
                    <v-col cols="7" md="3">
                      <div>
                        <span class="subtitle-1">{{ $t('tehtava.valmisyht') }}</span>
                      </div>
                      <div>
                        {{ $t('tehtava.tehtavia') }}: {{ valmisCount }} /
                        {{ filteredTehtavat.length }}
                      </div>
                      <div>
                        {{ $t('tehtava.painotus') }}: {{ $formatPisteet(painotusCount) }} /
                        {{ painotusYhtCount }}
                      </div>
                    </v-col>

                    <v-col cols="5" md="3">
                      <div>
                        <v-progress-circular :color="$getValmiusprosenttiColor(yht)"
                                             :size="$vuetify.breakpoint.xsOnly ? 80 : 110"
                                             :value="yht"
                                             :width="$vuetify.breakpoint.xsOnly ? 10 : 20">
                                    <span class="text-subtitle-1 text-h6 text-sm-h6">{{
                                        $formatPisteet(yht)
                                      }} %</span>
                        </v-progress-circular>

                      </div>
                    </v-col>

                  </v-row>
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  <tehtava-table :tehtavat="filteredTehtavat"/>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-fade-transition>
    <v-row v-if="!loading && !hasPermissions">
      <v-col class="mt-5" cols="auto">
        <h3>{{ $t('vastuualue.no_rights') }}</h3>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import api from '../apicollection';
import TehtavaTable from "@/components/Tehtava/TehtavaTable";

export default {
  name: 'TehtavaAsetuksetView',
  components: {TehtavaTable},
  data() {
    return {
      loading: true,
      tehtavat: [],
      valinnat: [],
      valinta: {},
      vastuualue: {},
      henkilot: [],
      henkilo: null,
      users: [],
      edit: {},
      saving: false,
      showEditDialog: false,
    };
  },
  computed: {
    hasPermissions() {
      return this.$hasEditPermission(this.vastuualue?.id);
    },
    search() {
      return this.$store.state.tehtavatSearch;
    },
    vuosi() {
      return this.$route.params.vuosi
    },
    valmisCount() {
      return this.filteredTehtavat.filter(t => t.tila === this.$TEHTAVA_TILA_VALMIS).length
    },
    painotusYhtCount() {
      return this.filteredTehtavat.reduce((c, p) => p.painotus + c, 0);
    },
    painotusCount() {
      return this.filteredTehtavat.reduce((c, p) => p.valmiusPisteet + c, 0);
    },
    filteredValinnat() {
      return this.valinnat;
    },
    filteredTehtavat() {
      let searchStrings = '';
      if (this.search.text) {
        searchStrings = this.search.text.toLowerCase().split(' ');
      }
      return this.tehtavat.filter(t => {

        if (t.tila === this.$TEHTAVA_TILA_ALOITTAMATTA && !this.search.aloittamatta) {
          return false;
        }
        if (t.tila === this.$TEHTAVA_TILA_KAYNNISSA && !this.search.kaynnissa) {
          return false;
        }
        if (t.tila === this.$TEHTAVA_TILA_VALMIS && !this.search.valmis) {
          return false;
        }
        if (this.search.text && this.search.text.length > 0) {
          const tString = [t.otsikko, t.kuvaus, t.vastuuuser && [t.vastuuuser.firstname, t.vastuuuser.lastname].join(' ')]
              .filter(Boolean).join(' ').toLowerCase();
          if (!searchStrings.every(s => tString.includes(s))) {
            return false;
          }
        }
        if (this.henkilo && this.henkilo.id && t.vastuuuserId !== this.henkilo.id) {
          return false;
        }
        return true;
      });
    },
    yht() {
      return (this.painotusCount / this.painotusYhtCount * 100) || 0
    }
  },
  methods: {
    async getValinta(id) {
      if (!id) return;
      const valinta = await api.getValinta(id);
      this.valinta = valinta;
    },
    async getTehtavat() {
      const tehtavat = await api.getTehtavat(this.vastuualue.id, this.$route.params.valintaId, this.vuosi);
      this.tehtavat = tehtavat;
    },
    async getValinnat() {
      const valinnat = await api.getValinnat(this.vastuualue, this.vuosi);
      this.valinnat = valinnat;
    },
    async getVastuualue() {
      const vastuualue = await api.getVastuualue(this.$route.params.vastuualueId);
      this.vastuualue = vastuualue;
    },
    async getHenkilot() {
      const henkilot = await api.getUsers();
      this.henkilot = henkilot;

      if (this.$route.query?.henkiloId) {
        this.henkilo = this.henkilot.find(h => h.id === this.$route.query.henkiloId);
      }
    },
    onChangeValinta(valinta) {
      this.valinta = valinta;
      if (valinta) {
        this.$router.replace({
          name: 'tehtavat_vuosi_vastuualue_valinta',
          params: {vuosi: this.vuosi, vastuualueId: this.$route.params.vastuualueId, valintaId: valinta.id},
          query: {
            henkiloId: this.henkilo?.id
          }
        })
        this.reloadAll();
      } else {
        this.$router.replace({
          name: 'tehtavat_vuosi_vastuualue',
          params: {vuosi: this.vuosi, vastuualueId: this.$route.params.vastuualueId},
          query: {
            henkiloId: this.henkilo?.id
          }
        })
        this.reloadAll();
      }
    },
    onChangeHenkilo(henkilo) {
      if (this.$route.query?.henkiloId === henkilo?.id) return;
      this.$router.replace({
        path: this.$route.path,
        query: {
          henkiloId: henkilo?.id
        }
      })
    },
    openEdit(tehtava) {
      if (tehtava == null) {
        this.$router.push({
          name: 'tehtava_uusi',
          query: {
            vastuualueId: this.$route.params.vastuualueId,
            valintaId: this.valinta.id,
            vuosi: this.vuosi,
          }
        })
        return;
      }
      this.$router.push({name: 'tehtava_muokkaus', params: {tehtavaId: tehtava.id}})
    },
    async reloadAll() {
      this.loading = true;
      await this.getVastuualue();
      await Promise.all([this.getTehtavat(), this.getValinnat(), this.getValinta(this.$route.params.valintaId), this.getHenkilot()])
      this.loading = false;
    }
  },
  watch: {
    henkilo() {
      this.onChangeHenkilo(this.henkilo);
    }
  },
  async mounted() {
    this.reloadAll();
    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss">
tr.tehtava-bg-100 {
  td:first-child {
    background-color: var(--v-success-lighten4);
    color: #000;
  }
}

tr.tehtava-bg-50 {
  td:first-child {
    background-color: var(--v-warning-lighten5);
    color: #000;
  }
}

</style>
<style lang="scss" scoped>

</style>
